import {Component, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";
import {BlockedNipAddDialogComponent} from "../blocked-nip-add-dialog/blocked-nip-add-dialog.component";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {validNip} from "../../../shared/validator/nip-validator";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {PartnerService} from "../../../shared/services/partner.service";
import {Dictionary} from "../../../shared/interface/dictionary";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {BlockedNipService} from "../../../shared/services/blocked-nip.service";
import {PartnerGus} from "../../../shared/interface/partner-gus";

@Component({
  selector: 'app-blocked-nip-add',
  templateUrl: './blocked-nip-add.component.html',
  styleUrls: ['./blocked-nip-add.component.scss']
})
export class BlockedNipAddComponent implements OnInit {
  @Input() dialogRef?: MatDialogRef<BlockedNipAddDialogComponent>;
  blockedNipForm: FormGroup;
  processingRequest = false;
  businessEntitiesFormArray: FormGroup[] = [];
  headquartersAddress: FormGroup;
  errors: any = {};
  userPermissions: ReplaySubject<UserPermissions>;


  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private snack: MatSnackBar,
    private partnerService: PartnerService,
    private blockedNipService: BlockedNipService,
    private formHelper: FormHelperService,
  ) {
    this.userPermissions = this.auth.getUserPermissions();

    this.headquartersAddress = this.formHelper.generateAddressFormGroup();

    this.blockedNipForm = fb.group({
      nip: fb.control('', [Validators.required, validNip()]),
      businessName: fb.control('', [Validators.required]),
      headquartersAddress: this.headquartersAddress,
      businessEntities: fb.array(this.businessEntitiesFormArray),
    });
  }

  ngOnInit(): void {
    this.addBusinessEntities();
  }

  getGus(): void {
    const nipValue = this.blockedNipForm.get('nip').value;

    if (!nipValue) {
      this.snack.open('Proszę wprowadzić NIP przed pobraniem danych z GUS', '', { duration: 2000 });
      return;
    }

    this.snack.open('Pobieranie danych z GUS');

    this.partnerService.gusInformation(nipValue)
      .subscribe((e: PartnerGus) => {
        this.snack.open('Pobrano dane z GUS', '', { duration: 2000 });
        this.blockedNipForm.get('businessName').setValue(e.fullName);
        const businessEntitiesControl = this.blockedNipForm.get('businessEntities') as FormArray;
        businessEntitiesControl.clear();

        e.businessEntities.forEach((businessEntity: any) =>
          this.addBusinessEntities(
            businessEntity.businessFullName,
            null,
            null,
            businessEntity.businessStreet,
            businessEntity.businessHouseNumber,
            businessEntity.businessApartmentNumber,
            businessEntity.businessCity,
            businessEntity?.businessZipCode,
            businessEntity?.businessState,
            businessEntity.businessPostCity,
            businessEntity.businessDistrict,
            businessEntity.businessCommune
          )
        );

        if (e.address.state) {
          e.address.stateId = e.address.state.id;
        }

        this.formHelper.setAddress(e.address, this.headquartersAddress);

      }, (error: HttpErrorResponse) => {
        this.snack.open('Nie udało się pobrać danych z GUS', error.status.toString(), {
          duration: 2000
        });
      });
  }


  addBusinessEntities(businessFullName?: string, businessFirstName?: string, businessLastName?: string, businessNip?: string,
                      businessRegon?: string, businessEmail?: string, businessPhone?: string, businessStreet?: string,
                      businessHouseNumber?: string, businessApartmentNumber?: string, businessCity?: string, businessZipCode?: string,
                      businessState?: Dictionary, businessPostCity?: string, businessDistrict?: string, businessCommune?: string): void {

    const businessEntitiesControl = this.blockedNipForm.get('businessEntities') as FormArray;

    businessEntitiesControl.push(new FormGroup({
      businessNip: new FormControl(businessNip || '', []),
      businessStreet: new FormControl(businessStreet || '', []),
      businessHouseNumber: new FormControl(businessHouseNumber || '', []),
      businessApartmentNumber: new FormControl(businessApartmentNumber || ''),
      businessCity: new FormControl(businessCity || '', []),
      businessZipCode: new FormControl(businessZipCode || '', []),
      businessState: new FormControl(businessState?.id || '', []),
      businessPostCity: new FormControl(businessPostCity || '', []),
      businessDistrict: new FormControl(businessDistrict || '', []),
      businessCommune: new FormControl(businessCommune || '', []),
    }));
  }

  sendForm(): void {
    this.processingRequest = true;

    this.blockedNipService.blockNip(this.blockedNipForm.getRawValue())
      .subscribe(() => {
        this.snack.open('Pomyślnie zablokowano NIP', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas blokowania NIP wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.blockedNipForm, this.errors);
        }
      })
    ;
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
